import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment/moment';

@Pipe({
  name: 'epochDate',
})
export class EpochDatePipe implements PipeTransform {
  transform(value: number, dateFormat?: string): unknown {
    const __format = 'DD-MM-YYYY HH:mm:ss.SSSZZ';
    const format = dateFormat ? dateFormat : __format;
    return moment.unix(value).format(format);
  }
}
